import { BrowserRouter, Route, Routes } from "react-router-dom";
import { StarterRoutePath } from "./app.starter/configs/_starter.route-path";
import { OtherRoutePath } from "./app.other/configs/_other.route-path";
import { CoreUiRoutePath } from "./app.coreui/configs/_coreui.route-path";
import { useState } from "react";

export enum MainAppsRepo {
  Starter,
  Pss,
}

import AppPss from "./app.pss/AppPss";
import AppStarter from "./app.starter/AppStarter";
import AppOther from "./app.other/AppOther";
import AppCoreUi from "./app.coreui/AppCoreUi";

const Apps = () => {
  console.log("Apps Init...");
  const [app, setApp] = useState<MainAppsRepo>(MainAppsRepo.Pss);

  let MainApp: JSX.Element = (
    <Route path="/*" element={<AppPss changeApp={setApp} />} />
  );
  switch (app) {
    case MainAppsRepo.Starter:
      MainApp = <Route path="/*" element={<AppStarter changeApp={setApp} />} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Sub Applications e.g. named Other */}
        <Route
          path={`/${StarterRoutePath.Prefix}/*`}
          element={<AppStarter />}
        />
        <Route path={`/${CoreUiRoutePath.Prefix}/*`} element={<AppCoreUi />} />
        <Route path={`/${OtherRoutePath.Prefix}/*`} element={<AppOther />} />

        {/* Main Application */}
        {MainApp}
      </Routes>
    </BrowserRouter>
  );
};

export default Apps;
